// extracted by mini-css-extract-plugin
module.exports = {"schoolsOverflow":"Schools_schoolsOverflow__zn4Sw","schools":"Schools_schools__1IVWV","loop":"Schools_loop__y_WJJ","school":"Schools_school__2qRUM"};